export default "__VITE_ASSET__4fb504a0__"